import { Component, h, Prop } from "@stencil/core";
import { VisuallyHiddenProps } from "./f-visually-hidden-model";

@Component({
  tag: "f-visually-hidden",
  styleUrl: "f-visually-hidden.scss",
  shadow: true,
})
export class VisuallyHidden {
  @Prop() type: VisuallyHiddenProps["type"] = "span";

  render() {
    const CustomTag = this.type;
    return (
      <CustomTag>
        <slot />
      </CustomTag>
    );
  }
}
